import HomeAssumptionsAxaOwnLivePage from './HomeAssumptionsAxaOwnLivePage';

export default HomeAssumptionsAxaOwnLivePage;
